import { requestToken, request } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/settings`;

class SettingServices {
  /** Public: get login_notes for login page (no auth) */
  async getLoginNotes() {
    try {
      const response = await request.get(`${API_ROUTE}/get-login-notes`);
      return response;
    } catch (error) {
      console.error("Error in getLoginNotes:", error);
      throw error;
    }
  }

  /** Public: get brand title/subtitle for AppLogo (no auth) */
  async getBrand(opts = {}) {
    try {
      const response = await request.get(`${API_ROUTE}/get-brand`, undefined, {
        signal: opts.signal,
      });
      return response;
    } catch (error) {
      if (
        opts.signal?.aborted ||
        error?.name === "AbortError" ||
        error?.code === "ERR_CANCELED"
      )
        return;
      console.error("Error in getBrand:", error);
      throw error;
    }
  }

  async getSettingData(opts = {}) {
    try {
      const action = API_ROUTE + `/get-setting-data`;
      const response = await requestToken.get(action, undefined, {
        signal: opts.signal,
      });
      return response;
    } catch (error) {
      if (opts.signal?.aborted || error?.name === "AbortError" || error?.code === "ERR_CANCELED") return;
      console.error("Error in getSettingData:", error);
      throw error;
    }
  }

  async getSettingHistoryData(page, limit, filter, referenceType) {
    try {
      const params = new URLSearchParams({ page, limit, filter: String(filter) });
      if (referenceType) params.set("reference_type", referenceType);
      const response = await requestToken.get(`${API_ROUTE}/get-setting-history?${params.toString()}`);
      return response;
    } catch (error) {
      console.error("Error in getSettingHistoryData:", error);
      throw error;
    }
  }

  async UpdateSettingData(payload) {
    try {
      let action = API_ROUTE + `/update-setting-data`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.error("Errorin getYantraListData:", error);
      throw error;
    }
  }

  async UpdateLoginNotes(payload) {
    try {
      let action = API_ROUTE + `/update-login-notes`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.error("Errorin UpdateLoginNotes:", error);
      throw error;
    }
  }

  async UpdateHomeNotes(payload) {
    try {
      let action = API_ROUTE + `/update-home-notes`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.error("Errorin UpdateHomeNotes:", error);
      throw error;
    }
  }

  async UpdateLiveSessionNotes(payload) {
    try {
      let action = API_ROUTE + `/update-live-session-notes`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.error("Errorin UpdateLiveSessionNotes:", error);
      throw error;
    }
  }

  async updateRegistrationSetting(payload) {
    try {
      const response = await requestToken.post(
        `${API_ROUTE}/update-registration-setting`,
        payload
      );
      return response;
    } catch (error) {
      console.error("Error in updateRegistrationSetting:", error);
      throw error;
    }
  }

  async getDepositDiscount() {
    try {
      const response = await requestToken.get(`${API_ROUTE}/deposit-discount`);
      return response;
    } catch (error) {
      console.error("Error in getDepositDiscount:", error);
      throw error;
    }
  }

  async updateDepositDiscount(payload) {
    try {
      const response = await requestToken.post(
        `${API_ROUTE}/update-deposit-discount`,
        payload
      );
      return response;
    } catch (error) {
      console.error("Error in updateDepositDiscount:", error);
      throw error;
    }
  }

  async getWithdrawalFee() {
    try {
      const response = await requestToken.get(`${API_ROUTE}/withdrawal-fee`);
      return response;
    } catch (error) {
      console.error("Error in getWithdrawalFee:", error);
      throw error;
    }
  }

  async updateWithdrawalFee(payload) {
    try {
      const response = await requestToken.post(
        `${API_ROUTE}/update-withdrawal-fee`,
        payload
      );
      return response;
    } catch (error) {
      console.error("Error in updateWithdrawalFee:", error);
      throw error;
    }
  }

}

export default SettingServices;

